import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@app/environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'upload-logo',
  styleUrls: ['upload-logo.css'],
  templateUrl: './upload-logo.component.html'
})
export class UploadLogoComponent {
  @Input() logoUrl: string;
  @Output() onSuccess = new EventEmitter<boolean>();
  constructor(private modalService: NgbModal, private http: HttpClient) {
    //
  }

  public isUploading = false;
  public isUploaded = false;
  public hasUploadError = false;
  public hasValidationError = false;

  public uploadError = '';
  public validationError = '';
  public doneStatus = '';
  private modalReference: any;
  private url = environment.apiUrl + '/upload';

  public onFileChange(event) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const that = this;
      const fr = new FileReader;

      if (this.fileHasValidExtension(file)) {
        fr.onload = function () {
          const img = new Image;
          img.onload = function () {
            if (img.height <= 2000) {
              that.uploadFile(file);
            } else {
              that.hasValidationError = true;
              that.validationError = 'The image cannot be higher than 2000px!';
            }
          };
          img.src = fr.result;
        };
        fr.readAsDataURL(file);
      }
    }
  }

  /**
   * Open modal
   * @param content
   */
  public open(content) {
    this.modalReference = this.modalService.open(content, {windowClass: 'gray-modal'});
  }

  public close() {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  private fileHasValidExtension(file) {
    const extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();

    if (!['png', 'jpg', 'jpeg', 'gif'].includes(extension)) {
      this.hasValidationError = true;
      this.doneStatus = '';
      this.validationError = 'Unsupported file type!';

      return false;
    } else {
      return true;
    }
  }

  private uploadFile(file) {
    const formData: FormData = new FormData();
    const url = this.url;

    formData.append('image', file, file.name);

    this.uploadError = '';
    this.isUploading = true;

    this.http.post(url, formData).subscribe(() => {
    },
    (err) => {
      this.doneStatus = '';
      this.isUploading = false;
      this.hasUploadError = true;

      if (err.error.hasOwnProperty('image')) {
        this.uploadError = err.error.image;
      }
    }, () => {
      this.doneStatus = 'Your image was uploaded!';
      this.isUploaded = true;

      this.isUploading = false;
      this.hasUploadError = false;
      this.hasValidationError = false;

        if (this.modalReference) {
          this.modalReference.close('success');
          this.onSuccess.emit(true);
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/sidebar/upload-logo/upload-logo.component.ts